const access = {
  // HeroSection
  'access.hero.homeLink': 'Home',
  'access.hero.aboutLink': 'About the Academy',
  'access.hero.currentPage': 'Access',
  'access.hero.title': 'Access',
  'access.hero.titleEn': 'ACCESS',
  'access.hero.lead': 'Our campus is in Aomi, Koto-ku, Tokyo (Odaiba). All visits are by appointment only.',
  'access.hero.imgAlt': 'A butler standing at the entrance of the building in Aomi that houses the campus',

  // LocationTable
  'access.location.label': 'LOCATION',
  'access.location.title': 'How do I get to the campus?',
  'access.location.titleEn': 'Find Us in Odaiba, Tokyo',
  'access.location.lead': 'Our campus is in Aomi, Koto-ku, Tokyo (Odaiba) — approximately five minutes on foot from two Yurikamome Line stations.',
  'access.location.tableHeader': 'Campus Information',
  'access.location.0.label': 'Name',
  'access.location.0.value': 'The Japan Butler Academy (operated by The All Japan Butler Association)',
  'access.location.1.label': 'Address',
  'access.location.1.value': '2-7-4 Aomi, Koto-ku, Tokyo 135-0064',
  'access.location.2.label': 'Phone',
  'access.location.2.value': '+81-3-6824-4086',
  'access.location.2.note': 'Weekdays, 10:00–17:00',
  'access.location.3.label': 'Email',
  'access.location.3.value': 'info@butler-academy.jp',
  'access.location.4.label': 'Visits',
  'access.location.4.value': 'By appointment only',

  // TrainAccess
  'access.train.label': 'BY TRAIN',
  'access.train.title': 'Getting Here by Train',
  'access.train.titleEn': 'Via Yurikamome Line',
  'access.train.lead': 'The most convenient way to reach us is via the Yurikamome Line. Both Tokyo International Cruise Terminal Station and Telecom Center Station are approximately five minutes on foot.',
  'access.train.note': '* Approximately 15 minutes from Shimbashi Station and 10 minutes from Toyosu Station by Yurikamome. The Odaiba area is close to shopping facilities and waterfront parks, making it easy to combine your visit with a leisurely stop beforehand.',
  'access.train.0.name': 'Tokyo International Cruise Terminal Station',
  'access.train.0.line': 'Yurikamome Line',
  'access.train.0.time': 'approx. 5 min walk',
  'access.train.0.directions': 'Exit the station and proceed straight towards Aomi. Cross at the traffic lights, then turn right at the second corner. You will see the glass-fronted building ahead.',
  'access.train.1.name': 'Telecom Center Station',
  'access.train.1.line': 'Yurikamome Line',
  'access.train.1.time': 'approx. 5 min walk',
  'access.train.1.directions': 'Exit via the west exit and turn left. Cross the main intersection, then follow the Aomi Promenade. The campus is on the left approximately 400 metres ahead.',

  // MapSection
  'access.map.label': 'MAP',
  'access.map.title': 'View on Map',
  'access.map.titleEn': 'Campus Location',
  'access.map.address': '2-7-4 Aomi, Koto-ku, Tokyo',
  'access.map.googleMaps': 'Open in Google Maps',

  // VisitGuide
  'access.visit.label': 'VISIT',
  'access.visit.title': 'Before You Visit',
  'access.visit.titleEn': 'Visiting the Campus',
  'access.visit.lead': 'All visits — including campus tours, individual consultations, and taster sessions — are by appointment only. Please book in advance.',
  'access.visit.0.title': 'Appointment-Only Policy',
  'access.visit.0.text': 'As an active teaching facility, we are unable to admit unannounced visitors. To arrange a campus tour, please contact us by telephone (+81-3-6824-4086, weekdays 10:00–17:00), email (info@butler-academy.jp), or via our online contact form.',
  'access.visit.1.title': 'Campus Tours',
  'access.visit.1.text': 'Tours last approximately 30 minutes and are available on weekdays as well as class days (Saturdays and Sundays). We hope a visit will help you picture the atmosphere and the learning experience.',
  'access.visit.2.title': 'Enquiries & Bookings',
  'access.visit.2.text': 'In addition to campus tours, we welcome enquiries for individual consultations and taster-session bookings. All are by appointment — please feel free to reach out.',
  'access.visit.2.link0': 'Book a Consultation',
  'access.visit.2.link1': 'View Taster Session',
  'access.visit.2.link2': 'Contact Us',

  // FAQSection
  'access.faq.label': 'FAQ',
  'access.faq.title': 'Frequently Asked Questions',
  'access.faq.titleEn': 'Frequently Asked Questions',
  'access.faq.footer': 'For further enquiries, please use our contact form.',
  'access.faq.0.question': 'Which is the nearest station?',
  'access.faq.0.answer': 'Tokyo International Cruise Terminal Station and Telecom Center Station on the Yurikamome Line are both approximately five minutes on foot.',
  'access.faq.1.question': 'Can I visit without an appointment?',
  'access.faq.1.answer': 'All visits are by appointment only. Please book in advance via our contact form, by telephone (weekdays, 10:00–17:00), or by email.',
  'access.faq.2.question': 'Is there parking available?',
  'access.faq.2.answer': 'We recommend coming by public transport. If you need to travel by car, please contact us in advance to discuss options.',

  // MapSection
  'access.map.note': '* All visits are by appointment only — please book before coming.',

  // CTASection
  'access.cta.label': 'NEXT STEP',
  'access.cta.title': 'Get in Touch',
  'access.cta.body': 'All campus visits are by appointment. You are also welcome to book an individual consultation or a taster session from here.',
  'access.cta.note': '* Online consultations are also available.',
  'access.cta.consultation': 'Book a Consultation',
  'access.cta.seminar': 'View Taster Session',
  'access.cta.contact': 'Contact Us',

  // RelatedPages
  'access.related.label': 'LEARN MORE',
  'access.related.title': 'Related Pages',
  'access.related.titleEn': 'Explore Further',
  'access.related.viewLink': 'Learn more',
  'access.related.0.title': 'Facilities & Equipment',
  'access.related.0.desc': 'Our Odaiba campus and training environment',
  'access.related.1.title': 'Book a Consultation',
  'access.related.1.desc': 'Free individual consultations, online or in person',
  'access.related.2.title': 'One-Day Taster Session',
  'access.related.2.desc': 'Experience butler training in a single day',
  'access.related.3.title': 'Contact Us',
  'access.related.3.desc': 'Enquiries and general questions',

  // Last updated
  'access.lastUpdated': 'Last updated: 8 July 2026',
};

export default access;
